module.exports = __webpack_public_path__ + "static/media/creativity1.b39fc9c9.gif";